var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedInProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 22.3889C26 24.3837 24.3837 26 22.3889 26H3.61111C1.61706 26 0 24.3837 0 22.3889V3.61111C0 1.61633 1.61706 0 3.61111 0H22.3889C24.3837 0 26 1.61633 26 3.61111V22.3889Z",
    fill: "#326164"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.33398 9.38856H7.9451V21.6663H4.33398V9.38856ZM6.12871 7.94412H6.10848C5.03093 7.94412 4.33398 7.14101 4.33398 6.13784C4.33398 5.11301 5.0526 4.33301 6.14965 4.33301C7.24815 4.33301 7.92487 5.11301 7.9451 6.13784C7.9451 7.14029 7.24815 7.94412 6.12871 7.94412ZM21.6673 21.6663H18.0562V15.0948C18.0562 13.5074 17.1715 12.4241 15.7509 12.4241C14.6668 12.4241 14.0804 13.155 13.7958 13.8613C13.6918 14.1141 13.7229 14.8132 13.7229 15.1663V21.6663H10.1118V9.38856H13.7229V11.2779C14.2436 10.4719 15.059 9.38856 17.1448 9.38856C19.7289 9.38856 21.6666 11.0136 21.6666 14.642L21.6673 21.6663Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedInProfile);
export default __webpack_public_path__ + "static/media/LinkedInProfile.7ea4ca8b3fc8dd7bcc76e99dfef6640c.svg";
export { ForwardRef as ReactComponent };